module.exports = __webpack_public_path__ + "static/media/gallery.68c2c5ed.svg";